import { RadioGroupField } from "$components/rhf-fields";
import { ContactPointOwnership } from "elephant-web/gql";
import { useMemo } from "react";
import { useIntl } from "react-intl";

export enum PhoneOwnershipRadioOptions {
  Personal = "Personal",
  Shared = "Shared",
  None = "None",
}

// Utility map to switch betwen the radio options and the GQL contact point ownership enum.
export const phoneOwnershipToContactPointOwnerMap: Record<
  PhoneOwnershipRadioOptions,
  ContactPointOwnership | null
> = {
  [PhoneOwnershipRadioOptions.Personal]: ContactPointOwnership.Personal,
  [PhoneOwnershipRadioOptions.Shared]: ContactPointOwnership.Shared,
  [PhoneOwnershipRadioOptions.None]: null,
};

export const mapContactPointOwnerToPhoneOwnership = (
  contactPointOwner?: ContactPointOwnership | null,
): PhoneOwnershipRadioOptions => {
  if (!contactPointOwner) {
    return PhoneOwnershipRadioOptions.None;
  }
  return {
    [ContactPointOwnership.Personal]: PhoneOwnershipRadioOptions.Personal,
    [ContactPointOwnership.Shared]: PhoneOwnershipRadioOptions.Shared,
  }[contactPointOwner];
};

export const PhoneOwnershipRadioInput: FC<
  Omit<React.ComponentProps<typeof RadioGroupField>, "options">
> = (delegateProps) => {
  const { formatMessage } = useIntl();

  const phoneTypeRadioOptions = useMemo(
    () => [
      {
        value: PhoneOwnershipRadioOptions.Personal,
        label: formatMessage({
          id: "patient.PhoneOwnershipRadioInput.option.personal.label",
          defaultMessage: "Personal Phone",
        }),
      },
      {
        value: PhoneOwnershipRadioOptions.Shared,
        label: formatMessage({
          id: "patient.PhoneOwnershipRadioInput.option.shared.label",
          defaultMessage: "Shared Phone",
        }),
      },
      {
        value: PhoneOwnershipRadioOptions.None,
        label: formatMessage({
          id: "patient.PhoneOwnershipRadioInput.option.none.label",
          defaultMessage: "No Phone",
        }),
      },
    ],
    [formatMessage],
  );

  return <RadioGroupField {...delegateProps} options={phoneTypeRadioOptions} />;
};
